'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const ReadMoreCollectionView = require('framework/ui/view/readmore-collection');
const IdeaQuery = require('feedback/domain/value/idea-query');
const IdeaStateFactory = require('feedback/domain/factory/idea-state');
const IdeaCollectionRepository = require('feedback/domain/repository/idea-collection');
const ItemSelectViewTemplate = require('feedback/ui/template/admin/idea/select-item.hbs');
const ItemEmptyTemplate = require('feedback/ui/template/admin/idea/item-empty.hbs');
const Template = require('feedback/ui/template/admin/idea/selector.hbs');

const ItemEmptyView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item idea-item',
    template: ItemEmptyTemplate
});

const ItemSelectView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item idea-item',
    template: ItemSelectViewTemplate,
    templateContext: function() {
        return {
            url: `/feedback/admin/ideas/${this.model.id}`,
            commentNum: this.model.getCommentCount(),
            stateColor: this.model.getState().color,
            key: this.model.key,
            isSelected: _.contains(this.getOption('ideaKeys'), this.model.id)
        }
    },

    onAttach: function() {
        $.material.init();
    },
});

const IdeaSelectListView = ReadMoreCollectionView.extend({
    className: 'list',
    childView: ItemSelectView,
    emptyView: ItemEmptyView,
    childViewOptions: function() {
        return {
            ideaKeys: this.getOption('ideaKeys'),
        }
    },
});

const IdeaSelectView = Mn.View.extend({
    tagName: 'div',
    template: Template,
    regions: {
        ideaList: '.idea-list',
    },
    templateContext: function() {
        const state = IdeaStateFactory.build(this.getOption('states'));
        return {
            state: state.name,
            stateColor: state.color
        }
    },

    onRender: function () {
        const query = new IdeaQuery(this.getOption('states'));
        const collection = IdeaCollectionRepository.adminIdeasByQuery(query);

        collection
            .fetchFirstPage()
            .then(() => {
                this.showChildView('ideaList', new IdeaSelectListView({
                    collection: collection,
                    ideaKeys: this.getOption('ideaKeys')
                }));
            });
    },

    getSelectedIdeaKeys: function() {
        const checked_keys = $('.idea-list').find('input:checked').map(function() {
            return $(this).val();
        });
        return _.map(checked_keys, key => {
            return key.toString();
        });
    }
});

module.exports = IdeaSelectView;



// WEBPACK FOOTER //
// ./feedback/ui/view/admin/idea/selector.js